// good_english_data_1a_l03.js
// Good English 1A L03 - Who is it?
// 路由：/ge/1a/l03
//
// 音频规则：
// - 非最后一页: end = 下一个 start - 1
// - 最后一页: 无 end（播放到音频结尾）

const MEDIA_BASE = '/media/good-english/1a/l03';
const V = 'v1';

export const dataGoodEnglish1aL03 = {
  id: '1a-l03',
  title: 'L03 Who is it?',
  mediaBase: MEDIA_BASE,
  audio: `${MEDIA_BASE}/story.mp3?${V}`,
  pages: [
    { image: `${MEDIA_BASE}/page1_top.jpeg?${V}`, text: 'Who Is It?', start: 20, end: 25 },  // 26-1
    { image: `${MEDIA_BASE}/page1_bottom.jpeg?${V}`, text: 'Biff and Chip.', start: 26, end: 32 },  // 33-1
    { image: `${MEDIA_BASE}/page2_top.jpeg?${V}`, text: 'Mum and Kipper.', start: 33, end: 40 },  // 41-1
    { image: `${MEDIA_BASE}/page2_bottom.jpeg?${V}`, text: 'Floppy and a spaceman.', start: 41, end: 49 },  // 50-1
    { image: `${MEDIA_BASE}/page3.jpeg?${V}`, text: "No, it's Dad.", start: 50 },  // 最后页，无 end
  ],
};
